import { render, staticRenderFns } from "./pbb_minimal.vue?vue&type=template&id=10516bfb&"
import script from "./pbb_minimal.vue?vue&type=script&lang=js&"
export * from "./pbb_minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports